import accountsPayableReceivable from "./accounts-payable-receivable.json";
import bills from "./bills.json";
import finExManagerialReport from "./finex-managerial-report.json";
import planOfAccounts from "./plan-of-accounts.json";
import customerAndSupplier from "./customer-and-supplier.json";
import stockTransferHistory from "./stock-transfer-history.json";
import { CONCILIATION_PT_BR } from "#pages/backoffice/conciliation/translations/conciliation-pt-br";
import eventConference from "./event-conference.json";

export const backofficePT = {
	eventConference,
	accountsPayableReceivable,
	stockTransferHistory,
	bills,
	cashFlow: {
		pageTitle: "Fluxo de caixa",
		pageParagraph:
			"Essa ferramenta possibilita apurar o saldo disponível no momento e projetar o futuro.",
		tooltipMessage:
			"As linhas de categorias do nível {{level}} exibem a soma de todos os níveis agrupados dentro dela.",
		fileName: "fluxo-de-caixa",
		topActions: {
			lblAccountName: "Buscar por Conta",
			plhAccountName: "Insira o nome da conta",
			lblDate: "Filtrar por Vencimento",
			btnPdf: "Exportar para PDF",
			btnExcel: "Exportar para Excel",
		},
		totalizers: {
			income: "Total de Receitas",
			costs: "Total de Custos",
			expenses: "Total de Despesas",
			balance: "Total de Receitas, Custos e Despesas",
		},
		rowTotal: "Saldo do Período",
		rowHead: "Saldo inicial",
		rowTail: "Saldo do dia",
		viewPerDay: "Visualizar por dia",
		viewPerMonth: "Visualizar por mês",
		columns: {
			income: "Receitas",
			costs: "Custos",
			expenses: "Despesas",
			level: "Nível",
			name: "Nome",
			day: "Dia",
			month: "Mês",
		},
	},
	costCenter: {
		costCenter: "Centros de custo",
		addCostCenter: "Adicionar centro de custo",
		editCostCenter: "Editar centro de custo",
		namePlaceholder: "Nome do centro de custo",
		name: "Nome",
		action: "Ações",
	},
	planOfAccounts,
	bankAccounts: {
		titlePage: "Contas bancárias",
		addAccount: "Cadastrar conta",
		columnsTable: {
			name: "Nome",
			bank: "Banco",
			agency: "Agência",
			purpose: "Finalidade da conta",
			actions: "Ações",
			account: "Conta",
			cpfOrCnpj: "CPF/CNPJ",
			ownerName: "Titular",
			currentBalance: "Saldo atual",
			initialBalance: "Saldo inicial",
		},
		form: {
			newNameBankAccount: "Nome da conta",
			bank: "Instituição bancária",
			agency: "Código da agência",
			purpose: "Finalidade da conta",
			account: "Conta corrente com dígito",
			cpfOrCnpj: "CPF/CNPJ",
			ownerName: "Titular",
			addAccount: "Adicionar conta bancária",
			editAccount: "Editar conta bancária",
			namePlaceholder: "Insira um nome para a conta",
			bankPlaceholder: "Busque por instituição",
			bankEmpty: "Nenhuma instituição encontrada",
			purposePlaceholder: "Busque pelo tipo de conta",
			selectPurpose: "Selecione a finalidade da conta",
			followInstructions: "Siga as instruções para continuar",
			accessBankAccount:
				"Para continuar, acesse seu internet banking e verifique se é possível fazer o download do seu extrato em formato OFX.",
			verifyBankAccount:
				"Se o banco não exportar esse formato de arquivo, clique em Concluir para avançar sem a validação.",
			successContent:
				"As informações importadas do OFX estão de acordo com o preenchimento realizado na etapa anterior",
			inconsistentContent:
				"Algumas informações importadas do OFX não estão de acordo com o preenchimento realizado na etapa anterior. Ao prosseguir substituiremos as informações preenchidas pelas importadas.",
			emptyBankData:
				"Algumas informações necessárias para a validação da conta não estão presentes no arquivo OFX selecionado. Clique em continuar para finalizar o cadastro sem a validação.",
			imported: "Importadas",
			registered: "Registradas",
			titlesContentVerifield: {
				success: "Informações verificadas",
				inconsistency: "Informações conflitantes",
				emptyBankData: "Informações faltantes",
			},
			ofxTitles: {
				upload: "Clique ou arraste o arquivo OFX",
				file: "Arquivo OFX",
			},
			incompatibleFile: "Arquivo incompatível",
			purposeList: {
				inHouseFlow: "Caixa (fundo de troco)",
				creditCard: "Cartao de crédito",
				virtualWallet: "Carteira virtual",
				applicationAccount: "Conta investimento",
				checkingAccount: "Conta Corrente",
				savingsAccount: "Conta Poupança",
			},
			accountPlaceholder: "Insira a conta",
			agencyPlaceholder: "Insira o código",
			cpfPlaceholder: "000.000.000-00",
			ownerNamePlaceholder: "Nome do titular da conta",
			unlink: "Desvincular conta bancária",
			linkBankAccount: "Vincular conta bancária",
			defaultAccount: "Definir como conta principal:",
			defaultAccountTooltip:
				"A conta principal é utilizada para preencher automaticamente os formulários que necessitem dessa informação.",
			default: "Padrão",
			initialBalance: "Saldo inicial em R$",
			initialBalanceDate: "Data do saldo inicial",
			balancePlaceholder: "0,00",
			balanceDatePlaceholder: "dd/mm/aaaa",
			saveChanges: "Salvar alterações",
			addAccountButton: "Adicionar conta",
			errors: {
				required: "Campo obrigatório",
				name: "Digite um nome válido",
				account: "Digite um número de conta válido",
				agency: "Digite um número de agência válido",
				cpf: "CPF inválido",
				cnpj: "CNPJ inválido",
				formatInvalid: "Este tipo de formato não é suportado",
			},
		},
		confirmModal: {
			discardTitle: "Descartar alterações?",
			discardMessage: "As alterações que você fez não foram salvas e serão perdidas.",
			discardConfirm: "Descartar",
			discardCancel: "Continuar editando",
			editInfo: "Editar informações",
			cancelMessage:
				"Você não salvou as alterações realizadas. Deseja continuar mesmo assim?",
			cancelButton: "Sair sem salvar",
			confirmButton: "Salvar alterações",
			deleteAccount: "Excluir conta",
			deleteMessage:
				"A exclusão de conta é uma ação definitiva. Deseja prosseguir com a exclusão?",
			deleteTransferError:
				"A exclusão dessa conta não pode ser realizada pois está vinculada a pagamentos ou recebimentos registrados.",
			deleteMainError:
				"A exclusão dessa conta não pode ser realizada pois está registrada como conta principal.",
			updateMainAccount: "Alterar conta principal",
			updateMainAccountMessage:
				"Já existe uma conta cadastrada como principal neste local, caso você prossiga essa conta será substituída. Deseja continuar ainda assim?",
			confirmUpdate: "Alterar conta",
			deactivateTitle: "Desativar conta",
			deactivateQuestion: "Certeza que deseja desativar essa conta?",
			deactivateMessage:
				"Ao desativar a conta nós manteremos ela como histórico para você consultar, porém não será mais possível atrelar essa conta a novos lançamentos.",
			deactivateConfirm: "Desativar conta",
		},
		subtitlePage:
			"Cadastre, gerencie e acompanhe as transações das suas principais contas bancárias",
		tabs: {
			active: "Contas ativas",
			inactive: "Contas desativadas",
		},
		emptyTab: {
			active: {
				title: "Nenhuma conta ativa",
				subtitle:
					'As contas ativas aparecem aqui. Reative uma conta na aba "Contas desativadas" ou cadastre uma nova.',
			},
			inactive: {
				title: "Nenhuma conta desativada",
				subtitle:
					"As contas que você desativar aparecem aqui. O histórico de movimentações é preservado e você pode reativá-las quando quiser.",
			},
		},
		comingSoon: "Em breve",
		zigCard: {
			title: "Conta ZIG",
			viewExtract: "Ver extrato",
			platform: "Disponível na plataforma",
			withdraw: "Disponível para saque",
			anticipation: "Disponível para antecipação",
			future: "Lançamentos futuros",
		},
		card: {
			viewTransactions: "Ver transações",
			agencyAbbr: "Ag.",
			accountAbbr: "C/C.",
			inactiveBadge: "Desativada",
		},
		migration: {
			banner: {
				title: "Atualize o saldo das suas contas bancárias",
				description:
					"Suas contas bancárias têm uma cara nova. Para que seus saldos apareçam corretamente na nova experiência, atualize suas contas com o saldo mais recente.",
			},
			badge: "Atualizar saldo",
			accountWarningTooltip: "Acesse os detalhes da conta e atualize o saldo",
		},
		switch: {
			activate: "Ativar conta",
			deactivate: "Desativar conta",
		},
		menu: {
			ariaLabel: "Ações da conta",
			editData: "Editar dados da conta",
			updateBalance: "Atualizar saldo",
		},
		emptyStateTitle: "Nenhuma conta bancária cadastrada",
		emptyStateSubtitle: "Adicione sua primeira conta bancária para começar a usar",
		notification: {
			deleteAccount: "Conta excluída com sucesso",
			createAccount: "Conta criada com sucesso",
			updateAccount: "Conta editada com sucesso",
			accountActivated: "Conta ativada com sucesso",
			accountDeactivated: "Conta desativada com sucesso",
		},
	},
	reports: {
		noComponent: "Aguarde em breve estará disponível",
		reportNames: {
			expense: {
				perDescripion: "Despesa por Descrição",
				perDay: "Despesa por Dia",
				perType: "Despesa por Tipo",
				perCategory: "Despesa por Categoria",
				perCostCenter: "Despesa por Centro de Custo",
				perHistory: "Despesa Histórico",
				perAnything: "Despesa Pago a.",
			},
			receipts: {
				perDescripion: "Receita por Descrição",
				perDay: "Receita por Dia",
				perType: "Receita por Tipo",
				perCategory: "Receita por Categoria",
				perCostCenter: "Receita por Centro de Custo",
				perHistory: "Receita Histórico",
				perAnything: "Receita Recebido de...",
			},
			cashFlow: {
				extract: "Extrato",
				expensses: "Despesas/Receitas",
				history: "Histórico",
				demonstrative: "Demonstrativo",
			},
		},
		graphs: {
			totalExpenses: "Total despesas",
			totalReceipts: "Total recebimentos",
			finalBalance: "Saldo final",
			periodBalance: "Balanço do período",
			previousBalance: "Saldo anterior",
			date: "Data",
			description: "Descrição",
			category: "Categoria",
			receipts: "Receitas",
			expenses: "Despesas",
			dateCaps: "DATA",
			receiptCaps: "RECEBIMENTO",
			expenseCaps: "DESPESA",
			valueCaps: "VALOR",
			totalCaps: "TOTAL",
			type: "Tipo",
			costCenterCaps: "CENTRO DE CUSTO",
			tax: "Imposto",
			receipt: "Receita",
			expense: "Despesa",
			result: "Resultado antes do imposto",
			profit: "Lucro no exercício",
			descriptionCaps: "DESCRIÇÃO",
			value: "Valor",
			balance: "Balanço",
			period: "Período",
			until: "até",
			totalReceived: "Total Recebido",
			totalPaid: "Total Pago",
			finalBalanceExtract: "Balanço final",
			periodBalanceExtract: "Balanço no período",
			previousBalanceExtract: "Balanço previo",
			supplierCaps: "FORNECEDOR",
			typeCaps: "TIPO",
		},
	},
	billType: {
		categories: "Categorias",
		addCategory: "Adicionar categoria de conta",
		addType: "Adicionar tipo de conta",
		createCategory: "Criar categoria de conta",
		editCategory: "Editar categoria de conta",
		categoryName: "Nome da categoria de conta",
		createTypeIn: "Criar tipo de conta em {{categoryName}}",
		editTypeIn: "Editar tipo de conta em {{categoryName}}",
		createType: "Criar tipo de conta",
		editType: "Editar tipo de conta",
		typeName: "Nome do tipo conta",
		name: "Nome",
		actions: "Ações",
	},
	finExManagerialReport,
	customerAndSupplier,
	viewLevel: "Visualizar nível {{level}}",
	conciliation: CONCILIATION_PT_BR,
};
